module.exports = __webpack_public_path__ + "fonts/Dancing-Bold.ttf!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Dancing-Bold.ttf
// module id = 44
// module chunks = 0